/**
 * Screen sizes.
 */

// Leaving out iPhone 5 sizing (320px) as user percentage is very small.
export const device = {
    mobileS: `375px`,
    mobile: `414px`,
    mobileL: `480px`,
    tabletS: `768px`,
    tablet: `1024px`,
    tabletL: `1280px`,
    laptopS: `1366px`,
    laptop: `1600px`,
    laptopL: `1920px`
};
